import React from 'react';
import { Card } from 'primereact/card';

type ActivityItem = {
    id: string;
    type: string;
    title: string;
    description: string;
    timestamp: string;
    period: string;
    location?: string;
    user: {
        name: string;
        avatar?: string;
    };
    icon?: string;
    status?: string;
};

type RecentActivityCardProps = {
    activities: ActivityItem[];
};

const RecentActivityCard: React.FC<RecentActivityCardProps> = ({ activities }) => {
    const getActivityIcon = (type: string, icon?: string) => {
        if (icon) return icon;

        switch (type) {
            case 'organization':
                return 'pi pi-building';
            case 'venue':
                return 'pi pi-map-marker';
            case 'staff':
                return 'pi pi-users';
            case 'menu':
                return 'pi pi-list';
            case 'security':
                return 'pi pi-shield';
            case 'system':
                return 'pi pi-cog';
            case 'performance':
                return 'pi pi-chart-line';
            case 'subscription':
                return 'pi pi-credit-card';
            default:
                return 'pi pi-info-circle';
        }
    };

    // Group activities by period
    const groupedActivities = activities.reduce(
        (acc, activity) => {
            const period = activity.period || 'Today';
            if (!acc[period]) {
                acc[period] = [];
            }
            acc[period].push(activity);
            return acc;
        },
        {} as { [key: string]: ActivityItem[] }
    );

    const periods = ['Today', 'This Week'];

    return (
        <div className="recent-activity-card dashboard-card-wrapper coming-soon-card">
            <Card title="Recent Activity">
                <div className="activity-columns">
                    {periods.map((period) => (
                        <div key={period} className="activity-column">
                            <div className="column-header">{period}</div>
                            <div className="column-content">
                                {(groupedActivities[period] || []).map((activity) => (
                                    <div key={activity.id} className="activity-item">
                                        <div className={`activity-icon ${activity.type}`}>
                                            <i className={getActivityIcon(activity.type, activity.icon)}></i>
                                        </div>
                                        <div className="activity-content">
                                            <div className="activity-title">{activity.title}</div>
                                            <div className="activity-description">{activity.description}</div>
                                            {activity.location && <div className="activity-location">{activity.location}</div>}
                                        </div>
                                        <div className="activity-time">{activity.timestamp}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </Card>
        </div>
    );
};

export default RecentActivityCard;
